import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';

$(() => {
  const additionalDetailsSubmitButton = $('#auction-registration-next-button');
  let additionalDetailsErrors = [];

  EVENT_BUS.on(ADDITIONAL_DETAILS_EVENTS.ADD_ERROR, ({ error }) => {
    if (!additionalDetailsErrors.includes(error)) {
      additionalDetailsErrors.push(error);
    }
    updateAdditionalDetailsSubmitButtonState();
  });

  EVENT_BUS.on(ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR, ({ error }) => {
    if (additionalDetailsErrors.includes(error)) {
      const errorIndex = additionalDetailsErrors.indexOf(error);
      additionalDetailsErrors.splice(errorIndex, 1);
    }
    updateAdditionalDetailsSubmitButtonState();
  });

  const updateAdditionalDetailsSubmitButtonState = () => {
    const disabled = !!additionalDetailsErrors.length;
    additionalDetailsSubmitButton.attr('disabled', disabled);
  };
});
